import { Vehicle } from '@otw/models';

/** True when Pending Sale requires permission or an owner override code. */
export function needsPendingSaleNotPurchasedGate(
  vehicle: Pick<Vehicle, 'purchased_for_inventory'>,
  canMarkPendingSaleNotPurchased: boolean,
): boolean {
  return vehicle.purchased_for_inventory !== true && !canMarkPendingSaleNotPurchased;
}

export function vehiclesNeedingPendingSaleNotPurchasedGate(
  vehicles: Array<Pick<Vehicle, 'id' | 'stock_number' | 'purchased_for_inventory' | 'pending_sale_not_purchased_notify'>>,
  canMarkPendingSaleNotPurchased: boolean,
) {
  return vehicles.filter((vehicle) =>
    needsPendingSaleNotPurchasedGate(vehicle, canMarkPendingSaleNotPurchased),
  );
}
